

// import Swiper bundle with all modules installed
//import swiper from 'swiper/bundle';

// Import Swiper bundle optimized
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);


window.swiper = Swiper;

let sliders = Array.prototype.slice.call(
	document.querySelectorAll('.swiper-container[data-slug]')
);

setTimeout(function() {
	sliders.forEach(function (slider) {

		//console.log(slider.dataset);

		var slider_slug = slider.dataset.slug; // slider.getAttribute('data-slug');
		var slider_config = slider.dataset.config; // slider.getAttribute('data-config');

		switch (slider_config) {
            // 6 cards by slide
            case 'sixth':
                new Swiper('.swiper-container[data-slug='+slider_slug+']', {
                    direction: 'horizontal',
                    slidesPerView: 2,
                    spaceBetween: 16,
                    speed: 400,
					watchOverflow: true,
					observer: true,
					observeParents: true,
                    navigation: {
                        nextEl: '[data-slug='+slider_slug+'] .swiper-button-next',
                        prevEl: '[data-slug='+slider_slug+'] .swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: 3,
                          spaceBetween: 16,
                        },
                        1024: {
                          slidesPerView: 6,
                          spaceBetween: 24,
                        },
                    },
                });
                break;
			// 4 cards by slide
			case 'quarter':
				new Swiper('.swiper-container[data-slug='+slider_slug+']', {
					direction: 'horizontal',
					slidesPerView: 2,
					spaceBetween: 16,
					speed: 400,
					watchOverflow: true,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: '[data-slug='+slider_slug+'] .swiper-button-next',
						prevEl: '[data-slug='+slider_slug+'] .swiper-button-prev',
					},
					breakpoints: {
						768: {
						  slidesPerView: 2,
						  spaceBetween: 32,
						},
						1024: {
						  slidesPerView: 4,
						  spaceBetween: 32,
						},
					},
				});
				break;
            // 4 cards by slide | desktop > 3 cards in tablet
            case 'quarter-third':
                new Swiper('.swiper-container[data-slug='+slider_slug+']', {
                    direction: 'horizontal',
                    slidesPerView: 2,
                    spaceBetween: 16,
                    speed: 400,
                    watchOverflow: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '[data-slug='+slider_slug+'] .swiper-button-next',
                        prevEl: '[data-slug='+slider_slug+'] .swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: 3,
                          spaceBetween: 32,
                        },
                        1024: {
                          slidesPerView: 4,
                          spaceBetween: 32,
                        },
                    },
                });
                break;
			// 2 cards by slide
			case 'half':
				new Swiper('.swiper-container[data-slug='+slider_slug+']', {
					direction: 'horizontal',
					slidesPerView: 2,
					spaceBetween: 16,
					speed: 400,
					watchOverflow: true,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: '[data-slug='+slider_slug+'] .swiper-button-next',
						prevEl: '[data-slug='+slider_slug+'] .swiper-button-prev',
					},
					breakpoints: {
						768: {
						  slidesPerView: 2,
						  spaceBetween: 32, // 36 in design but better align with 32
						},
					},
				});
				break;
			case 'single':
				new Swiper('.swiper-container[data-slug='+slider_slug+']', {
					direction: 'horizontal',
					slidesPerView: 1,
					spaceBetween: 16,
					speed: 400,
					watchOverflow: true,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: '[data-slug='+slider_slug+'] .swiper-button-next',
						prevEl: '[data-slug='+slider_slug+'] .swiper-button-prev',
					},
					breakpoints: {
						768: {
						  slidesPerView: 1,
						  spaceBetween: 32,
						},
						1024: {
						  slidesPerView: 1,
						  spaceBetween: 48,
						},
					},
				});
				break;
            // 2 cards by slide desktop + laptop + tablet - but single on mobile
            case 'half-product':
                new Swiper('.swiper-container[data-slug='+slider_slug+']', {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 400,
                    watchOverflow: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '[data-slug='+slider_slug+'] .swiper-button-next',
                        prevEl: '[data-slug='+slider_slug+'] .swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 32, // 36 in design but better align with 32
                        },
                    },
                });
                break;
            case 'landing':
			case 'circuit':
                new Swiper('.swiper-container[data-slug='+slider_slug+']', {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 400,
                    watchOverflow: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '[data-slug='+slider_slug+'] .carousel-control-next',
                        prevEl: '[data-slug='+slider_slug+'] .carousel-control-prev',
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: 1,
                          spaceBetween: 32,
                        },
                        1024: {
                          slidesPerView: 1,
                          spaceBetween: 48,
                        },
                    },
                });
                break;
            case 'gallery':
                new Swiper('.swiper-container[data-slug='+slider_slug+']', {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 400,
                    watchOverflow: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '[data-slug='+slider_slug+'] .btn-next',
                        prevEl: '[data-slug='+slider_slug+'] .btn-prev',
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: 1,
                          spaceBetween: 32,
                        },
                        1024: {
                          slidesPerView: 1,
                          spaceBetween: 48,
                        },
                    },
                    on: {
                        init: function() {
                            const gallery_slug = this.el.dataset.slug;
                            if(gallery_slug){
                                // get Title
                                const galleryActiveItem = this.activeIndex;
                                const galleryItem = document.querySelector('[data-slug='+gallery_slug+'] .swiper-slide[data-num="'+ galleryActiveItem.toString() +'"]');
                                // Update Title
                                const galleryTitle = galleryItem?.dataset?.title;
                                const titleElement = document.querySelector('[data-slug='+gallery_slug+'] .gallery-zoom-title');
                                if(galleryTitle){
                                    titleElement.innerText = galleryTitle;
                                }
                            }
                        },
                        slideChange: function() {
                            const gallery_slug = this.el.dataset.slug;
                            if(gallery_slug){
                                // get Title
                                const galleryActiveItem = this.activeIndex;
                                const galleryItem = document.querySelector('[data-slug='+gallery_slug+'] .swiper-slide[data-num="'+ galleryActiveItem.toString() +'"]');
                                // Update Title
                                const galleryTitle = galleryItem?.dataset?.title;
                                const titleElement = document.querySelector('[data-slug='+gallery_slug+'] .gallery-zoom-title');
                                if(galleryTitle){
                                    titleElement.innerText = galleryTitle;
                                }
                            }
                        },
                    },
                });
                break;
            case 'categories':
                var swiperCategories = new Swiper('.swiper-container[data-slug='+slider_slug+']', {
                    direction: 'horizontal',
                    slidesPerView: 'auto',
                    spaceBetween: 8,
                    speed: 400,
                    watchOverflow: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '[data-slug='+slider_slug+'] .btn-scroll-horizontal.next',
                        prevEl: '[data-slug='+slider_slug+'] .btn-scroll-horizontal.prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 'auto',
                            spaceBetween: 8,
                        },
                        1024: {
                            slidesPerView: 'auto',
                            spaceBetween: 12,
                        },
                    },
                });

                var swiperCategoriesContainer = document.querySelector('.swiper-container[data-slug='+slider_slug+']');
                var swiperCategoriesButtons = document.querySelector('.swiper-buttons[data-slug='+slider_slug+']');

                swiperCategories.on('unlock', function () {
                    // swiper is unlock - items cross horizontal view // need watchOverflow = true
                    swiperCategoriesContainer.setAttribute('data-swiper-enable', 'true');
                    swiperCategoriesButtons.setAttribute('data-swiper-gradient', 'true');
                });

                swiperCategories.on('slideChange', function (event) {
                    swiperCategoriesContainer.setAttribute('data-swiper-gradient', 'true');
                    swiperCategoriesButtons.setAttribute('data-swiper-gradient', 'true');
                    if( event.isBeginning ){
                        swiperCategoriesContainer.setAttribute('data-swiper-gradient', 'onlyright');
                        swiperCategoriesButtons.setAttribute('data-swiper-gradient', 'onlyright');
                    }
                    if( event.isEnd ){
                        swiperCategoriesContainer.setAttribute('data-swiper-gradient', 'onlyleft');
                        swiperCategoriesButtons.setAttribute('data-swiper-gradient', 'onlyleft');
                    }
                });

                break;
			default:
					console.log('Swiper not initialized : data-config is missing');
				break;
		}
	});
}, 10);
